<template>
  <section id="talk">
    <base-card>
      <v-container>
        <v-row>
          <v-col v-for="(feature, i) in features"
                 :key="i"
                 cols="12"
                 md="4"
                 sm="6">
            <!-- <v-hover v-slot:default="{ hover }"> -->
            <v-card height="100%"
                    shaped>
              <!-- :elevation="hover ? 6 : 0" -->
              <!-- :outlined="!hover" -->
              <v-card-title>
                <v-icon :color="feature.color"
                        :size="64"
                        v-text="feature.icon" />
                <h3 class="ml-5 grey--text text--darken-1">{{feature.title}}</h3>
              </v-card-title>
              <v-card-text>
                <v-list-item v-for="(item, j) in feature.skills"
                             :key="j"
                             dense>
                  <v-list-item-icon>
                    <v-icon x-small>mdi-checkbox-blank-circle</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{item}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card-text>
            </v-card>
            <!-- </v-hover> -->
          </v-col>
        </v-row>
      </v-container>

      <!-- <v-divider class="my-5 mx-3" /> -->

    </base-card>
  </section>
</template>

<script>
  export default {
    name: "SkillsContents",

    /******************************************
     *                Components              *
     ******************************************/
    components: {},

    /******************************************
     *                 Computed               *
     ******************************************/
    computed: {},
    /******************************************
     *                   Data                 *
     ******************************************/
    data: () => ({
      features: [
        {
          icon: "mdi-language-csharp",
          color: "primary",
          title: ".Net",
          skills: [".Net C#", "Wpf", "Prism"],
        },
        {
          icon: "mdi-language-javascript",
          color: "red",
          title: "Web",
          skills: ["Javascript", "VueJS / Vuetify", "NodeJS"],
        },

        {
          icon: "mdi-android",
          color: "green",
          title: "Mobile",
          skills: ["Android", "Java"],
        },
        {
          icon: "mdi-database",
          color: "orange",
          title: "Database",
          skills: ["PostgreSql", "Oracle", "MySql", "MongoDb"],
        },
        {
          icon: "mdi-laptop-windows",
          color: "blue",
          title: "System",
          skills: ["Windows", "Debian", "Ubuntu"],
        },
        {
          icon: "mdi-map-marker-path",
          color: "light-green",
          title: "GIS",
          skills: ["PostGis", "Dot Spatial", "Google Map"],
        },
        {
          icon: "mdi-adobe",
          color: "red",
          title: "Adobe",
          skills: ["Photoshop", "Premiere Pro"],
        },
      ],

      //  "mdi-face-agent",
      //  "mdi-laptop-windows",
      //  "mdi-microsoft-windows",
    }),

    /******************************************
     *                 Methods                *
     ******************************************/
    methods: {
      initFeatures() {
        //
      },
    },

    /******************************************
     *                 Mounted                *
     ******************************************/
    mounted() {},

    watch: {},
  };
</script>
